import { IPostbackSendAllLang } from '../../../types/lang'
import { postbackSendFormLang } from './postbackSendForm'


export const postbackSendAllLang: IPostbackSendAllLang = {
	...postbackSendFormLang,
}